const styles = {
  container: {
    width: '100%',
    maxWidth: '700px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    margin: '0 auto',
    padding: '15px',
    boxSizing: 'border-box',
  },
};

export default styles;
